import StudentStatuses from '@/utils/constants/student/studentStatuses';
import { Colors } from '../../common';

export default {
  methods: {
    getColor(status) {
      let color = '';
      switch (status) {
        case StudentStatuses.PreRegistro:
          color = Colors.PINK;
          break;
        case StudentStatuses.Registro:
        case StudentStatuses.Evaluado:
        case StudentStatuses.Elegible:
          color = Colors.YELLOW;
          break;
        case StudentStatuses.Disponible:
        case StudentStatuses.Inactivo:
          color = Colors.BROWN;
          break;
        case StudentStatuses.Servido:
          color = Colors.GREEN;
          break;
        case StudentStatuses.Egreso:
          color = Colors.CREAM;
          break;
        case StudentStatuses.NoElegible:
          color = Colors.VIOLET;
          break;
      }
      return color;
    },
  },
};
